import { NgModule } from '@angular/core';
import { EventsService } from './services/events.service';
import { AnalyticsModule } from '@titan/devkit/analytics';

@NgModule({
    imports: [AnalyticsModule],
    providers: [EventsService],
})
export class EventsModule {}
